import * as React from "react";
const SvgDownCaret = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 7, viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L6 6L11 1", stroke: "currentColor" }));
export default SvgDownCaret;
